module.exports = __webpack_public_path__ + "static/media/PopUpImg.f0787853.jpg";